import { z } from 'zod';

export const CandidateTagsFormSchema = z.object({
  candidateTags: z.array(z.string().uuid()),
});

export type CandidateTagsFormType = z.infer<typeof CandidateTagsFormSchema>;
